<template>
  <app-page :head="data.head" :body="data.body" />
</template>

<script setup>
const { params, query } = useRoute();
const preview = query.preview ? `&preview=${query.preview}` : "";
const { data } = await useFetch(
  `/api/page_trends?lng=${params.locale}&slug=${params.id}${preview}`
);
</script>
